export default __webpack_public_path__ + "static/media/Icon53.09410ddf.svg";